import { ApplicationState } from 'app/types-store';
import { TranslatedState } from 'app/types-shared';
import { ReceiveTextCollection, RequestTextCollection } from './action-types';
import { api } from './api';
import { textCollection } from 'app/constants';
import { translations } from './translations';
import get from 'lodash/get';

export type TextCollectionActions = ReceiveTextCollection | RequestTextCollection;

export const textCollectionActionCreators = {

  /**
   * Load the miminum set of data needed for the current view location.
   */
  loadTextCollection: (paths: string[], language: number) =>
   async (dispatch: any, getState: () => ApplicationState) => {
      const area: string = paths[0];
      const areaId: number = textCollection[area];
      const state: TranslatedState = getState()[area];

      const alreadyRequested = state?.textsLanguage === language && 
        (!!state?.texts && Object.keys(state?.texts).length > 0) ||
        state?.textsFetching;

      if (!language || alreadyRequested || !areaId) {
        return;
      }
      const languageId = [area, language];

      dispatch(new RequestTextCollection(area, language));

      if (translations.areValid(languageId)) {
        dispatch(new ReceiveTextCollection(area, language, translations.get(languageId)));        
        return;
      }

      const response = await api.textCollection(language, Number(areaId));
      const texts = get(response, 'json.data');
      const expires = response.expires;

      if (!!texts && !!response.expires) {
        translations.add(languageId, texts, expires);
      }

      dispatch(new ReceiveTextCollection(area, language, texts));
    }
};
